import React from 'react'
import ReactDOM from 'react-dom'
import { Router, browserHistory } from 'react-router'
import { Provider } from 'react-redux'
import routes from './routes'
import configureStore from './stores/configureStore'

import './containers/Html.scss'

const store = configureStore(window.INITIAL_STATE)

window.digitalData = Object.assign({}, window.digitalData, {
  page: window.digitalData && window.digitalData.page ? window.digitalData.page : {},
  user: window.digitalData && window.digitalData.user ? window.digitalData.user : [{}]
})

const app = (
  <Provider store={store}>
    <Router history={browserHistory}>{routes}</Router>
  </Provider>
)

if (process.env.NODE_ENV === 'development') {
  ReactDOM.render(app, document.getElementById('root'))
} else {
  ReactDOM.hydrate(app, document.getElementById('root'))
}



// WEBPACK FOOTER //
// ./src/client.js